import React, { FunctionComponent, useState, useEffect, useReducer } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Checkbox,
  withStyles
} from "@material-ui/core";
import { getTenantUsers } from "../../Axios";
import ListReducer, { ListReducerActionType } from "../../util/ListReducer";
import styles from "./styles";

type Props = {
  open: boolean;
  toggleOpen: any;
  handleCreate?: any;
  classes: any;
};

const CreateTeamsModal: FunctionComponent<Props> = props => {
  const { open, toggleOpen, handleCreate, classes } = props;
  const [users, setUsers] = useState<any>([]);
  const [selectedUsers, selectedUserDispatcher] = useReducer(ListReducer<any>("id"), []);

  const handleCheck = (event, user) => {
    selectedUserDispatcher({
      type: event.target.checked ? ListReducerActionType.Add : ListReducerActionType.Remove,
      data: event.target.checked ? user : user.id
    });
  };

  useEffect(() => {
    getTenantUsers().then((data: any) => setUsers(data.value));
  }, []);

  return (
    <Dialog fullWidth={true} maxWidth={"sm"} open={open} onClose={toggleOpen} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Microsoft Teams</DialogTitle>
      <DialogContent>
        <DialogContentText>Select team members ({selectedUsers.length} selected)</DialogContentText>
        <table className={classes.table}>
          {users.map(user => (
            <tr key={user.id}>
              <td>
                <Typography>{user.displayName}</Typography>
              </td>
              <td>
                <Checkbox checked={selectedUsers.includes(user)} onChange={e => handleCheck(e, user)} />
              </td>
            </tr>
          ))}
        </table>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleOpen} color="primary">
          Cancel
        </Button>
        <Button disabled={!selectedUsers.length} onClick={() => handleCreate(selectedUsers)} color="primary">
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(CreateTeamsModal);
